/* eslint-disable no-restricted-globals */
import { useDispatch, useSelector } from 'react-redux'

import { hideModalMessage, hideOverlay, hoverSidebar, showModalMessage, showOverlay, toggleSidebar } from 'Modules/store/actions'
import { makeSelectGlobal } from 'Modules/store/selectors'

export const useRoot = () => {
  const dispatch = useDispatch()

  const { portfolios, sidebarCompact, sidebarHover, isShowModalMessage, message, type, isShowOverlay } = useSelector(makeSelectGlobal())

  const toggleSidebarAction = (payload) => dispatch(toggleSidebar(payload))
  const hoverSidebarAction = (payload) => dispatch(hoverSidebar(payload))
  const showModalMessageAction = (payload) => dispatch(showModalMessage(payload))
  const hideModalMessageAction = () => dispatch(hideModalMessage())
  const showOverlayAction = () => dispatch(showOverlay())
  const hideOverlayAction = () => dispatch(hideOverlay())

  return {
    portfolios,
    type,
    sidebarCompact,
    sidebarHover,
    isShowModalMessage,
    message,
    isShowOverlay,
    toggleSidebarAction,
    hoverSidebarAction,
    showModalMessageAction,
    hideModalMessageAction,
    showOverlayAction,
    hideOverlayAction
  }
}
